import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './components/table/table.component';
import { TableModule as PrimeTableModule } from 'primeng/table';
import { PaginatorModule } from '../paginator/paginator.module';
import { DatatableCellAnchorDirective } from './components/table/directives/datatable-cell-anchor.directive';
import { BaseDatatableCellComponent } from './components/table/base-datatable-cell.component';
import { ActionCellComponent } from './components/table/cell-components/action-cell.component';
import { ButtonModule } from '../button/button.module';
import { TitleWithCaptionComponent } from './components/table/cell-components/title-with-caption.component';
import { DatatableHeaderAnchorDirective } from './components/table/directives/datatable-header-anchor.directive';
import { InputIconHeaderComponent } from './components/table/header-components/input-icon-header.component';
import { InputModule } from '../input/input.module';
import { InputMultiselectHeaderComponent } from './components/table/header-components/input-multiselect-header.component';
import { StatusFilterHeaderComponent } from './components/table/header-components/status-filter-header.component';
import { StatusIndicatorCellComponent } from './components/table/cell-components/status-indicator-cell.component';
import { ProgressBarCellComponent } from './components/table/cell-components/progress-bar-cell.component';
import { ProgressBarModule } from '../progress-bar/progress-bar.module';

@NgModule({
  declarations: [
    TableComponent,
    DatatableCellAnchorDirective,
    DatatableHeaderAnchorDirective,
    BaseDatatableCellComponent,
    ActionCellComponent,
    TitleWithCaptionComponent,
    InputIconHeaderComponent,
    InputMultiselectHeaderComponent,
    StatusFilterHeaderComponent,
    StatusIndicatorCellComponent,
    ProgressBarCellComponent,
  ],
  imports: [
    CommonModule,
    PrimeTableModule,
    PaginatorModule,
    ButtonModule,
    InputModule,
    ProgressBarModule,
  ],
  exports: [TableComponent],
})
export class TableModule {}
